// src/panel/src/Panel.tsx
import * as React from "react";

// ../../node_modules/@vanilla-extract/recipes/createRuntimeFn/dist/vanilla-extract-recipes-createRuntimeFn.esm.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var shouldApplyCompound = (compoundCheck, selections, defaultVariants) => {
  for (var key of Object.keys(compoundCheck)) {
    var _selections$key;
    if (compoundCheck[key] !== ((_selections$key = selections[key]) !== null && _selections$key !== void 0 ? _selections$key : defaultVariants[key])) {
      return false;
    }
  }
  return true;
};
var createRuntimeFn = (config) => (options) => {
  var className = config.defaultClassName;
  var selections = _objectSpread2(_objectSpread2({}, config.defaultVariants), options);
  for (var variantName in selections) {
    var _selections$variantNa;
    var variantSelection = (_selections$variantNa = selections[variantName]) !== null && _selections$variantNa !== void 0 ? _selections$variantNa : config.defaultVariants[variantName];
    if (variantSelection != null) {
      var selection = variantSelection;
      if (typeof selection === "boolean") {
        selection = selection === true ? "true" : "false";
      }
      var selectionClassName = (
        // @ts-expect-error
        config.variantClassNames[variantName][selection]
      );
      if (selectionClassName) {
        className += " " + selectionClassName;
      }
    }
  }
  for (var [compoundCheck, compoundClassName] of config.compoundVariants) {
    if (shouldApplyCompound(compoundCheck, selections, config.defaultVariants)) {
      className += " " + compoundClassName;
    }
  }
  return className;
};

// src/panel/src/Panel.css.ts
var children = createRuntimeFn({ defaultClassName: "Panel__6uq91b8", variantClassNames: { display: { center: "Panel_display_center__6uq91b9", stretch: "Panel_display_stretch__6uq91ba", wrap: "Panel_display_wrap__6uq91bb", auto: "Panel_display_auto__6uq91bc" }, scroll: { true: "Panel_scroll_true__6uq91bd", false: "Panel_scroll_false__6uq91be" } }, defaultVariants: {}, compoundVariants: [] });
var childrenDisplay = createRuntimeFn({ defaultClassName: "Panel__6uq91bf", variantClassNames: { display: { stretch: "Panel_display_stretch__6uq91bg", wrap: "Panel_display_wrap__6uq91bh", center: "Panel_display_center__6uq91bi", auto: "Panel_display_auto__6uq91bj" } }, defaultVariants: {}, compoundVariants: [] });
var container = "Panel__6uq91b0";
var gradient = createRuntimeFn({ defaultClassName: "Panel__6uq91bl", variantClassNames: { bottomGradient: { true: "Panel_bottomGradient_true__6uq91bm", false: "Panel_bottomGradient_false__6uq91bn" } }, defaultVariants: {}, compoundVariants: [] });
var header = createRuntimeFn({ defaultClassName: "Panel__6uq91b1", variantClassNames: { display: { stretch: "Panel_display_stretch__6uq91b2", wrap: "Panel_display_wrap__6uq91b3", center: "Panel_display_center__6uq91b4", auto: "Panel_display_auto__6uq91b5" } }, defaultVariants: {}, compoundVariants: [] });
var link = "Panel__6uq91b7";
var noChildrenMessage = "Panel__6uq91bk";
var title = "Panel__6uq91b6";

// src/panel/src/Panel.tsx
function Panel({
  children: children2,
  title: title2,
  ctaLabel,
  ctaLink,
  ctaCallback,
  noChildrenMessage: noChildrenMessage2,
  display = "auto",
  scroll = false,
  bottomGradient = false
}) {
  return /* @__PURE__ */ React.createElement("div", { className: container }, /* @__PURE__ */ React.createElement("div", { className: header({ display }) }, title2 && /* @__PURE__ */ React.createElement("div", { className: title }, title2), ctaLabel && ctaLink && /* @__PURE__ */ React.createElement("a", { href: ctaLink }, /* @__PURE__ */ React.createElement("span", { className: link }, ctaLabel)), ctaLabel && ctaCallback && /* @__PURE__ */ React.createElement("button", { onClick: () => ctaCallback() }, /* @__PURE__ */ React.createElement("span", { className: link }, ctaLabel))), /* @__PURE__ */ React.createElement(
    "div",
    {
      id: "-ui-panel-div-children-",
      className: children({ display, scroll })
    },
    children2 ? /* @__PURE__ */ React.createElement("div", { className: childrenDisplay({ display }) }, children2) : /* @__PURE__ */ React.createElement("div", { className: noChildrenMessage }, noChildrenMessage2)
  ), /* @__PURE__ */ React.createElement("div", { className: gradient({ bottomGradient }) }));
}
var Panel_default = React.forwardRef(Panel);
export {
  Panel_default as default
};
